import React, { useEffect, useRef } from "react"
import styles from "./index.module.scss"
import lottie from 'lottie-web'

const LoadingPage = () => {
  const lottieNode = useRef<any>(null)

  useEffect(() => {
    showLottie()
    return componentWillUnmount
  }, [])

  const componentWillUnmount = () => {
    lottie.destroy('loading-page')
  }

  const showLottie = () => {
    lottie.destroy('loading-page')
    import('./assets/loading.json').then((animationData) => {
      if (lottieNode.current) {
        lottie.loadAnimation({
          name: 'loading-page',
          container: lottieNode.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
        });
      }
    })
  }

  return (
    <div className={styles.loadingPage}>
      <div className={styles.loadingCont} ref={item => { lottieNode.current = item }}></div>
    </div>
  )
}

export default LoadingPage